import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function Gallery() {
    const [items, setItems] = useState([]);
    const [lightbox, setLightbox] = useState(null);
    useEffect(() => { api.get("/gallery").then((r) => setItems(r.data)); }, []);

    return (
        <div data-testid="gallery-page" className="grain">
            <section className="border-b border-line py-16 md:py-24 bg-bg-soft">
                <div className="max-w-7xl mx-auto px-5 md:px-10">
                    <div className="text-gold text-xs tracking-[0.4em] uppercase font-bold mb-4">The Reign</div>
                    <h1 className="h-display text-6xl md:text-8xl">Gallery</h1>
                </div>
            </section>
            <section className="max-w-7xl mx-auto px-5 md:px-10 py-16">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                    {items.map((g, i) => (
                        <button key={g.id} onClick={() => setLightbox(g)} data-testid={`gallery-item-${i}`} className="group relative overflow-hidden aspect-square block">
                            <div className="absolute inset-0 bg-cover bg-center group-hover:scale-110 transition-transform duration-700" style={{ backgroundImage: `url('${g.image_url}')` }} />
                            <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-colors" />
                            {g.title && (
                                <div className="absolute bottom-3 left-3 right-3 text-left">
                                    <div className="h-display text-sm">{g.title}</div>
                                </div>
                            )}
                        </button>
                    ))}
                </div>
                {items.length === 0 && <div className="text-center text-ink py-20">No photos yet.</div>}
            </section>

            {lightbox && (
                <div className="fixed inset-0 z-[60] bg-black/95 grid place-items-center p-6" onClick={() => setLightbox(null)} data-testid="lightbox">
                    <div className="max-w-5xl w-full">
                        <img src={lightbox.image_url} alt={lightbox.title || ""} className="w-full max-h-[80vh] object-contain" />
                        {(lightbox.title || lightbox.caption) && (
                            <div className="text-center mt-4">
                                {lightbox.title && <div className="h-display text-xl">{lightbox.title}</div>}
                                {lightbox.caption && <div className="text-ink text-sm mt-1">{lightbox.caption}</div>}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
